var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"subscriber",class:[
    'subscriber-video fill-height',
    { priority: _vm.stream.videoSource === 'screen' } ],on:{"dblclick":function($event){$event.stopPropagation();return (function () { return _vm.fullscreen('subscriber'); })($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }